function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useContext, useMemo, useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import GlobalNavContext from '../../../../context/GlobalNavContext.js';
import TrapdoorDescriptionColumn from '../../TrapdoorDescriptionColumn.js';
import TrapdoorProductListColumn from '../../TrapdoorProductListColumn.js';
import AccessibilityWrapper from '../AccessibilityWrapper.js';
import { PRODUCT_LIST_UK, PRODUCT_LIST } from './constants.js';
import messages from './messages.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function TrapdoorContentIndividuals({
  linkRefs,
  contentRefs,
  isInRewardsHubExperiment
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalNavContext),
    isIndia = _useContext.isIndia,
    isUKUser = _useContext.isUKUser;
  const individualsDescription = isIndia ? messages.individualsIndiaDescription : messages.individualsDescription;
  const productLinks = useMemo(() => {
    let links = isUKUser ? PRODUCT_LIST_UK : PRODUCT_LIST;
    if (!isInRewardsHubExperiment) {
      links = links.map(column => _objectSpread(_objectSpread({}, column), {}, {
        links: column.links.filter(link => link.intlLabelKey !== 'rewardsHub')
      }));
    }
    if (isIndia) {
      links = links.map(column => _objectSpread(_objectSpread({}, column), {}, {
        links: column.links.filter(link => ['trade', 'wallet'].includes(link.intlLabelKey))
      }));
    }
    return links;
  }, [isUKUser, isInRewardsHubExperiment, isIndia]);
  const setRef = useCallback(el => contentRefs['individuals'] = el, [contentRefs]);
  return /*#__PURE__*/jsxs(AccessibilityWrapper, {
    id: "global-nav-dropdown-individuals",
    children: [/*#__PURE__*/jsx(TrapdoorProductListColumn, {
      linkRefs: linkRefs,
      columnData: productLinks,
      messages: messages,
      columnKey: "individuals"
    }), /*#__PURE__*/jsx(TrapdoorDescriptionColumn, {
      ref: setRef,
      title: formatMessage(messages.individualsTitle),
      description: formatMessage(individualsDescription),
      linkText: formatMessage(messages.individualsLinkText),
      url: "https://www.coinbase.com/wallet",
      image: "https://static-assets.coinbase.com/growth/acquisition/global-nav/upsell/individuals_upsell.png"
    }, "global-nav-dropdown-individuals-description")]
  });
}
const IndividualsContent = /*#__PURE__*/memo(TrapdoorContentIndividuals);
export { IndividualsContent as default };
//# sourceMappingURL=Individuals.js.map
